export const ru = {
    additions: 'Дополнения: {additionsList}'
};
